module.exports = __webpack_public_path__ + "img/chevron-backward.75a5f6de.svg";